import { render } from "./IconMicrosoft.vue?vue&type=template&id=2131af18"
const script = {}

import exportComponent from "/tmp/deploys/543m16/clmo3v4lx00qx0uj22kk5f6ig/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__